var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import classnames from 'classnames';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MagnifyingGlassIcon from '../../../../assets/icons/magnifying-glass.svg';
import { AVA_DOMAIN } from '../../../constants';
import UserAvatar from '../../Avatars/UserAvatar';
import { users as Users } from '../../../services/api/ava';
import { getSnack } from '../../../utils/snackbar';
import { formatAvaName, isAvaRoomValid } from '../../../utils/search-ava-room';
import { getSocketIfExist } from '../../../utils/getSocket';
import { log } from '../../../utils/log';
import * as segment from '../../../utils/segment';
import { sendConnectionRequestMessage, sendUserQueryMessage } from '../../../utils/ws-v1';
import useStyles from './SearchAvaRoomInput.styles';
const SearchAvaRoomInput = ({ addNotification, electronCaptionMode, setInviteCardOpen, setJoiningStatus, setLoadingApp, user, }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { closeSnackbar, enqueueSnackbar } = useSnackbar();
    const [avaNameInput, setAvaNameInput] = useState('');
    const [suggestedUsers, setSuggestedUsers] = useState([]);
    const [inputFocused, setInputFocused] = useState(false);
    const handleUserQueryResponse = (message) => {
        const data = JSON.parse(message.data);
        log('websocketMessage', 'info', { message: data, direction: 'b2f' });
        if (data.type === 'user-query-response') {
            setSuggestedUsers(data.users.slice(0, 9));
        }
    };
    useEffect(() => {
        const socket = getSocketIfExist();
        if (socket) {
            socket.addEventListener('message', handleUserQueryResponse);
        }
        return () => {
            if (socket) {
                socket.removeEventListener('message', handleUserQueryResponse);
            }
        };
    }, []);
    const joinAvaRoom = (avaRoom) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isAvaRoomValid(avaRoom))
            return;
        setJoiningStatus('requested');
        setInviteCardOpen(false);
        setLoadingApp(true);
        const socket = getSocketIfExist();
        const id = sendConnectionRequestMessage(socket, 'default', { avaName: avaRoom }, {});
        let gotConnectionResponse = false;
        const handleConnectResponse = (message) => {
            const data = JSON.parse(message.data);
            const stopListening = () => {
                if (socket) {
                    socket.removeEventListener('message', handleConnectResponse);
                }
                setLoadingApp(false);
            };
            if (data.type === 'connection-response' && data.id === id) {
                log('websocketMessage', 'info', {
                    message: data,
                    direction: 'b2m',
                });
                gotConnectionResponse = true;
                // Show the error message if there was a problem connecting to the room.
                if (!data.value) {
                    setJoiningStatus('none');
                    stopListening();
                    gotConnectionResponse = false;
                    const errorMessage = t(`snackbar.request.${data.reason || 'unknownError'}`);
                    if (electronCaptionMode) {
                        addNotification({
                            text: errorMessage,
                            timestamp: Date.now(),
                            type: 'default',
                        });
                    }
                    else {
                        getSnack({ enqueueSnackbar, closeSnackbar })(errorMessage, {
                            variant: 'error',
                        });
                    }
                }
            }
            else if ((data.type === 'room-status' || data.type === 'room-status-update') && gotConnectionResponse) {
                setJoiningStatus('accepted');
                stopListening();
                segment.track('Joined Conversation', {
                    HostAvaName: data.host.avaName,
                    HostUserId: data.host.avaId,
                    'Join Method': 'Connect Request',
                });
                Users.updateJoinMetrics({
                    avaId: user.avaId,
                    firebaseAuthUID: user.firebaseAuthUID || user.id,
                    joinMetrics: {
                        'Total Joins': 1,
                        'Total Invites Connected Count': 0,
                    },
                });
            }
        };
        if (socket) {
            socket.addEventListener('message', handleConnectResponse);
        }
    });
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.top },
            React.createElement("span", { className: classes.avaLink },
                "web.",
                AVA_DOMAIN,
                "/"),
            React.createElement("div", { className: classnames(classes.inputContainer, {
                    [classes.inputContainerFocused]: inputFocused,
                }) },
                React.createElement("div", { className: classes.iconContainer },
                    React.createElement("img", { className: classes.icon, src: MagnifyingGlassIcon, alt: "" })),
                React.createElement("input", { className: classes.input, value: avaNameInput, placeholder: t('ccMode.inviteCard.enterRoomName'), onChange: (event) => {
                        const formattedAvaName = formatAvaName(event.target.value);
                        setAvaNameInput(formattedAvaName);
                        if (formattedAvaName) {
                            const socket = getSocketIfExist();
                            if (socket) {
                                sendUserQueryMessage(socket, formattedAvaName);
                            }
                        }
                    }, onKeyDown: (event) => {
                        if (['Enter'].includes(event.key)) {
                            joinAvaRoom(avaNameInput);
                        }
                    }, onFocus: () => setInputFocused(true), onBlur: () => setInputFocused(false), autoFocus: true }))),
        React.createElement("div", { className: classes.bottom }, suggestedUsers.map((user) => (React.createElement("div", { className: classes.card, key: user.avaName, onClick: () => joinAvaRoom(user.avaName) },
            React.createElement("div", { className: classes.avatar },
                React.createElement(UserAvatar, { height: 24, width: 24, user: user })),
            React.createElement("span", { className: classes.avaName }, user.avaName)))))));
};
export default SearchAvaRoomInput;
